import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { ReferenceManyField, Datagrid, TextField, ReferenceField } from 'react-admin';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'react-admin';
import { CREATE, UPDATE } from 'react-admin';
import { dataProvider } from "./dataProvider";
import Switch from '@material-ui/core/Switch';
import { Button } from '@material-ui/core';

const optionsList = [
  "ads_disabled",
  "recommendations",
  "user_portal",
  "portal_opt_in",
  "use_existing_payment",
  "order_tracking",
  "download_tax_records",
  "disable_account_data"
];

const LABEL = "flags";

class Toggle extends Component {
  handleChange = (e, checked) => {
    let { record: { key, info_id, keys }, refreshView, showNotification } = this.props;
    const hasKey = keys.indexOf(key) !== -1;

    if (!hasKey && checked) {
      keys = keys.slice();
      keys.push(key);
    } else if (!checked) {
      keys = keys.filter(f => f !== key);
    }

    dataProvider(UPDATE, 'info', { id: info_id, data: { data: keys } })
      .then(() => {
        showNotification(key + ' ' + (checked ? 'enabled' : 'disabled'));
      })
      .catch((e) => {
        console.log(e);
        showNotification('Error: Failed to ' + (checked ? 'enable' : 'disable') + ' ' + key, 'warning');
      })
      .finally(() => {
        refreshView();
      });
  };

  render() {
    const { record: { key, keys } } = this.props;
    return <Switch checked={keys.indexOf(key) !== -1} onChange={this.handleChange} />;
  }
}

let ConnectedToggle = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(Toggle);

class Enabler extends Component {
  handleCreate = (e) => {
    let { authId, userId, refreshView, showNotification } = this.props;

    dataProvider(CREATE, 'info', { data: { auth_id: authId, user_id: userId, label: LABEL, data: [] } })
      .then(() => {
        showNotification('Enabled');
      })
      .catch((e) => {
        console.log(e);
        showNotification('Error: Failed to enable');
      })
      .finally(() => {
        refreshView();
      });
  };

  render() {
    return <Button variant="contained" color="primary" onClick={this.handleCreate}>
      Enable
    </Button>;
  }
}

let ConnectedEnabler = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(Enabler);

const DataMapper = (props) => {
  let { data, ids } = props;

  let keys = {};
  optionsList.forEach(key => {
    keys[key] = { key, info_id: ids[0], user_id: data[ids[0]].user_id, keys: data[ids[0]].data };
  });

  let newProps = { ...props, data: keys, ids: optionsList };
  delete newProps.children;

  return React.Children.map(props.children, child => {
    return React.cloneElement(child, newProps);
  });
};

const FeaturesController = (props) => {
  let { authId, userId, title, ...rest } = props;

  if (props.ids && props.ids.length > 0) {
    return <DataMapper {...rest}>
      <Datagrid>
        <TextField source="key" label={title} sortable={false} />
        <ConnectedToggle label="Enabled" />
        <ReferenceField label="Site" source="user_id" reference="user">
          <TextField label="Domain" source="domain" />
        </ReferenceField>
      </Datagrid>
    </DataMapper>;
  } else {
    return <ConnectedEnabler authId={authId} userId={userId} />;
  }
};

export default class ToggleOptions extends Component {
  render() {
    let { title, subheader, ...rest } = this.props;
    let { record: { id, user_id } } = rest;

    return (
      <Card style={this.props.style || {}}>
        <CardHeader title={title} subheader={subheader || "Enable/Disable options for this user"} />
        <CardContent>
          <ReferenceManyField label={title} filter={{ label: LABEL, user_id }} reference="info" target="auth_id" {...rest}>
            <FeaturesController title={title} authId={id} userId={user_id} {...rest} />
          </ReferenceManyField>
        </CardContent>
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/ToggleOptions.js